import { useEffect, useMemo } from 'react'

import { useGrowthBook } from '@growthbook/growthbook-react'
import { getClientId } from '@infrastructure/GoogleTagManager'

export const useSetGaUserIdAttributes = (): null => {
    const growthbook = useGrowthBook()

    const clientId = useMemo(() => getClientId(), [])

    useEffect(() => {
        if (!growthbook || !clientId) return

        growthbook.setAttributes({
            ...growthbook.getAttributes(),
            ga_user_id: clientId,
        })
    }, [growthbook, clientId])

    return null
}
